// Tanév rendje / naptár esemény-típusok megjelenítési metaadatai (szín + ikon + címke).
// A típusok TÖRZSADATOK (naptar_tipus, Admin → Naptártípusok); ez a lista csak a
// tartalék, ha a /api/naptar-tipusok lekérés még nem jött meg vagy elbukott.
export const TANEVRENDJE_TIPUSOK = [
  { value: 'program', label: 'Program', color: '#3880ff', icon: 'school' },
  { value: 'tabor', label: 'Tábor', color: '#2dd36f', icon: 'sunny' },
  { value: 'szunet', label: 'Szünet', color: '#ffc409', icon: 'bed' },
  { value: 'unnepely', label: 'Ünnepély / megemlékezés', color: '#eb445a', icon: 'ribbon' },
  { value: 'ertekezlet', label: 'Értekezlet / szülői', color: '#92949c', icon: 'people' },
  { value: 'meres', label: 'Mérés', color: '#6030ff', icon: 'analytics' },
  { value: 'vizsga', label: 'Vizsga', color: '#f4a942', icon: 'document-text' },
  { value: 'tanitas_nelkuli', label: 'Tanítás nélküli munkanap', color: '#936b4f', icon: 'calendar' },
  { value: 'kirandulas', label: 'Kirándulás', color: '#0cd1e8', icon: 'bus' },
  { value: 'verseny', label: 'Verseny', color: '#ff6b9d', icon: 'trophy' },
  { value: 'egyeb', label: 'Egyéb', color: '#5260ff', icon: 'ellipsis-horizontal' },
];

/**
 *  Naptári esemény kártyacíme az órarend eseménysávjában.
 *
 *  Az `ikon` az ion-icon NEVE (pl. `bed`). Ez korábban nyers szövegként került a címbe,
 *  ezért a kártyán az ikon helyett az volt kiírva, hogy „bed". Itt valódi <ion-icon>
 *  elem megy ki – a FullCalendar eseménytartalma HTML-ként rendelődik –, az esemény
 *  nevét pedig escape-eljük, mert így HTML-be kerül.
 */
export function esemenyCimHtml(ikon: string, nev: string): string {
  const biztonsagos = /^[a-z0-9-]+$/.test(String(ikon || '')) ? String(ikon) : '';
  const cim = String(nev ?? '').replace(/[&<>"]/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] as string));
  return (biztonsagos
    ? `<ion-icon name="${biztonsagos}" style="vertical-align:-2px;margin-right:4px"></ion-icon>`
    : '') + cim;
}
